const statCounter = {
	elem: {
		$counters: document.querySelectorAll('[data-counter]')
	},
	countSpeed: 25,
	countBy: 1, // Default increment. Change by setting [data-count-by] on element
	observer: null,
	observerOptions: {
	  rootMargin: '0px',
	  threshold: 1.0
	},

	init() {
		this.bindUIActions();
	},
	handleIntersect(entries) {
		entries.forEach(
			function(entry){
				if (entry.intersectionRatio > 0) {
					statCounter.startCounting(entry.target);
					statCounter.observer.unobserve(entry.target);
				}
			}
		);
	},
	startCounting($counter) {
		let countTo = $counter.getAttribute('data-count-to');
		let countBy = $counter.getAttribute('data-count-by') ? $counter.getAttribute('data-count-by') : statCounter.countBy;
		$counter.current = 0;
		$counter.countTo = parseFloat(countTo);
		$counter.countBy = parseFloat(countBy);
		$counter.decimalPlaces = countTo.split('.')[1] ? countTo.split('.')[1].length : 0;
		statCounter.increment($counter);
	},
	
	increment($counter) {
		if(typeof $counter.countTo === 'number' && typeof $counter.countBy === 'number') {			
			$counter.current = $counter.current + $counter.countBy;
			if($counter.current <= $counter.countTo) {
				$counter.innerHTML = $counter.current.toLocaleString('en-US', { maximumFractionDigits: $counter.decimalPlaces, minimumFractionDigits: $counter.decimalPlaces });
				setTimeout(function(){
					statCounter.increment($counter);
				}, statCounter.countSpeed);
			} else {
				// Jump to target if next increment exceeds its value
				$counter.innerHTML = $counter.countTo.toLocaleString('en-US', { maximumFractionDigits: $counter.decimalPlaces, minimumFractionDigits: $counter.decimalPlaces });
			} 
		}
	},
	bindUIActions() {
		if(statCounter.observer === null) {
			statCounter.observer = new IntersectionObserver(statCounter.handleIntersect, statCounter.observerOptions);
		}
		statCounter.elem.$counters.forEach(function( $counter ) {
			if($counter.getAttribute('data-count-to')) {
				$counter.innerHTML = 0;
				statCounter.observer.observe($counter);
			}
		});
	}
};

export { statCounter };
